import React, { useState } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import uRLs from "../../baseUtils";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import Convertinvoice from "../../../components/pages/sale/ConvertInvoice";
import QRCode from "qrcode";
import InvoiceActionFooter from "../a4Invoices/common/InvoiceActionFooter";
import InvoiceInfoSidebar from "../a4Invoices/common/InvoiceInfoSidebar";
import InvoiceToggleActionCard from "../a4Invoices/common/InvoiceToggleActionCard";
import InvoicePreviewRenderer from "./common/InvoiceHA4PreviewRender";
import InvoiceModalLayout from "./common/InvoiceModalLayout ";
import { useInvoiceData } from "./common/useInvoiceData";
import {
  capitalizeFirstLetter,
  joinAddress,
  loadImageDimensions,
  urlToBase64,
} from "./common/invoiceUtils";
import PaySettleModal from "./common/PaySettleModal ";
import handleError from "../../../constants/handleError";
import AxiosInstance from "../../AxiosInstance";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import ReturnSaleInvoice from "./ReturnSaleInvoice";
const LegendExecutiveInvoice = ({
  isData,
  onClose,
  onDataUpdate,
  onDataChange,
  onListSaleRefresh,
  selectedOption,
  isActive,
  optData,
  setOptData,
}) => {
  const invoiceData = useInvoiceData({
    isData,
    onClose,
    onDataUpdate,
    onDataChange,
    optData,
    setOptData,
  });
  const {
    data,
    globalData,
    selectedTheme,
    selectedSize,
    qrCodeDataUrl,
    setSelectedSize,
    terms,
    latestVersion,
    actualPaidAmount,
    download,
    setDownload,
    billing,
    setBilling,
    selectTermalOption,
    setSelectTermalOption,
    selectHALFA4Option,
    setSelectHALFA4Option,
    isBtnLoading,
    setBtnLoading,
    isPaySettleModalOpen,
    setIsPaySettleModalOpen,
    isMainModalOpen,
    setIsMainModalOpen,
    saleLoading,
    closeAuto,
    setCloseAuto,
    showConfirm,
    setShowConfirm,
    handleResetSale,
    saleTime,
    storeSettings,
    isUser,
    handleSelectedSale,
    handlelatestSale,
    isBillReceipt,
    documentTitle,
    handleGenerateInvoice,
    handleModeConfirm,
    hasShipping,
  } = invoiceData;
  const [returnData, setIsReturnData] = useState("");
  const [isReturnView, setIsReturnView] = useState(false);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const handleClose = () => {
    setIsMainModalOpen(false);
    setIsReturnView(false);
    onClose();
  };
  const invLabel = isBillReceipt ? "Bill #:" : "Invoice #:";
  const invDate = isBillReceipt ? "Bill Date:" : "Invoice Date:";
  const invTime = isBillReceipt ? "Bill Time:" : "Invoice Time:";
  const handleSelectedReturnSale = async (sale) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/salereturn/${sale?._id}`,
      );
      setIsReturnData(response.data.results);
      setIsReturnView(true);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };
  const generateInvoice1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const PADDING = 5;
    let boxStartY = 10;
    const BORDER_COLOR = selectedTheme?.templateTheme?.borderColor || "#000000"; // pure black
    const BORDER_WIDTH = 0.1;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const hasShipping =
      globalData.saleto?.shippingAddress &&
      optData.isCustomerDisplay &&
      (globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2);

    // ===== TITLE =====
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(documentTitle, pageW / 2, 8, { align: "center" });

    // Define column split points
    const col1 = hasShipping ? PADDING + 70 : PADDING + 80;
    const col2 = hasShipping ? PADDING + 128 : PADDING + 145; // Slightly adjusted for better spacing
    const col3 = hasShipping ? PADDING + 162 : PADDING + 145;

    // Initialize Y trackers for each column
    let leftY = boxStartY + 4;
    let centerY = boxStartY + 4;
    let shippingY = boxStartY + 4;
    let rightY = boxStartY + 4;

    // ==============================
    // LEFT SECTION (Company)
    // ==============================
    if (globalData?.salefrom?.image) {
      try {
        const imagePath =
          uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 20;
        const maxHeight = 15;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalWidth = width * ratio;
        const finalHeight = height * ratio;
        // Use leftY as reference
        doc.addImage(
          base64,
          "PNG",
          MARGIN_LEFT + 2,
          leftY - 2,
          finalWidth,
          finalHeight,
        );
      } catch {
        doc.text("LOGO", MARGIN_LEFT + 2, leftY + 5);
      }
    }

    const leftX = 24;
    const availableWidth = col1 - (MARGIN_LEFT + leftX) - 2;
    doc.setFontSize(7.2);
    doc.setFont("Inter-Bold", "bold");
    const companyTitleLines = doc.splitTextToSize(
      globalData?.salefrom?.title || "",
      availableWidth,
    );

    companyTitleLines.forEach((line) => {
      doc.text(line, MARGIN_LEFT + leftX, leftY);
      leftY += 3.5;
    });
    doc.text(
      `GSTIN ${globalData?.salefrom?.gstnumber || ""}`,
      MARGIN_LEFT + leftX,
      leftY,
    );

    const fromAddress = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode,
    );
    doc.setFont("Inter-Regular", "normal");
    leftY += 4;
    const fromAddrLines = doc.splitTextToSize(fromAddress, availableWidth); // Wrapped size
    doc.text(fromAddrLines, MARGIN_LEFT + leftX, leftY);
    leftY += fromAddrLines.length * 4;
    leftY -= 1;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Mobile", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.phone || ""}`,
      MARGIN_LEFT + leftX + 10,
      leftY,
    );

    leftY += 3;

    // Email
    doc.setFont("Inter-Bold", "bold");
    doc.text("Email", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.email || ""}`,
      MARGIN_LEFT + leftX + 8,
      leftY,
    );

    let centerX = col1 + 2;
    let centerValueX = col2 - 2;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(7.5);
    doc.text(
      `Customer Details: ${
        globalData.saleto && optData.isCustomerDisplay ? "" : "-"
      }`,
      centerX,
      centerY,
    );
    centerY += 4;
    doc.setFont("Inter-Regular", "normal");
    if (globalData.saleto && optData.isCustomerDisplay) {
      const name = globalData?.saleto?.name || "";
      const nameWidth = col2 - centerX - 2;
      const nameLines = doc.splitTextToSize(name, nameWidth);
      if (name) {
        nameLines.forEach((line) => {
          doc.text(line, centerX, centerY);
          centerY += 3.5;
        });
      }
      doc.setFont("Inter-Regular", "normal");
      const custAddress = [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
        globalData?.saleto?.pincode,
      ]
        .filter(Boolean)
        .join(", ");
      const custAddrLines = doc.splitTextToSize(custAddress, 55);
      doc.text(custAddrLines, centerX, centerY);
      centerY += custAddrLines.length * 4;
      centerY -= 1;
      const contactInfo = `Ph: ${globalData?.saleto?.phone || ""} | GSTIN: ${
        globalData?.saleto?.gstnumber || ""
      }`;
      if (globalData?.saleto?.phone || globalData?.saleto?.gstnumber) {
        centerY += 1;
        doc.text(contactInfo, centerX, centerY);
      }
      if (globalData?.saleto?.email) {
        centerY += 4;
        doc.text(`Email ${globalData?.saleto?.email || ""}`, centerX, centerY);
      }
      if (globalData?.saleto?.referenceid) {
        centerY += 4;
        doc.text(
          `Reference No: ${globalData?.saleto?.referenceid || ""}`,
          centerX,
          centerY,
        );
      }
      if (globalData?.saleto?.fssai) {
        centerY += 4;
        doc.text(`FASSI: ${globalData?.saleto?.fssai || ""}`, centerX, centerY);
      }
      if (globalData?.saleto?.pannumber) {
        centerY += 4;
        doc.text(
          `PAN: ${globalData?.saleto?.pannumber || ""}`,
          centerX,
          centerY,
        );
      }
      if (globalData?.saleto?.cinnumber) {
        centerY += 4;
        doc.text(
          `CIN: ${globalData?.saleto?.cinnumber || ""}`,
          centerX,
          centerY,
        );
      }
      if (globalData?.saleto?.state) {
        centerY += 4;
        doc.setFont("Inter-Bold", "bold");
        doc.text("Place of Supply:", centerX, centerY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(globalData?.saleto?.state || "", centerValueX, centerY, {
          align: "right",
        });
      }
    }

    if (hasShipping && optData.isCustomerDisplay) {
      // ==============================
      // NEW SECTION (Shipping Details)
      // ==============================
      let shipX = col2 + 2;
      const shipWidth = col3 - shipX - 2;
      doc.setFont("Inter-Bold", "bold");
      doc.text("Shipping Details:", shipX, shippingY);
      shippingY += 4;
      doc.setFont("Inter-Regular", "normal");

      // Fetching shipping information from dataset
      const shippingAddress = [
        globalData?.saleto?.shippingAddress?.addressline1,
        globalData?.saleto?.shippingAddress?.addressline2,
        globalData?.saleto?.shippingAddress?.district,
        globalData?.saleto?.shippingAddress?.state,
        globalData?.saleto?.shippingAddress?.pincode,
      ]
        .filter(Boolean)
        .join(", ");

      const shipAddrLines = doc.splitTextToSize(shippingAddress, shipWidth);
      doc.text(shipAddrLines, shipX, shippingY);
      shippingY += shipAddrLines.length * 3.5;
    }

    let labelX = col3 + 2;
    let valueX = pageW - PADDING - 2; // The rightmost edge

    doc.setFont("Inter-Bold", "bold");
    doc.text(invLabel, labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleno || "", valueX, rightY, { align: "right" });
    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text(invDate, labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      DateConverter.ISOToDisplayFormat(globalData?.saledate).date || "",
      valueX,
      rightY,
      { align: "right" },
    );

    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text(invTime, labelX, rightY);
    const invDateTime = DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone),
    ).time;
    doc.setFont("Inter-Regular", "normal");
    doc.text(invDateTime || "", valueX, rightY, { align: "right" });
    const headerBottomY = Math.max(leftY, centerY, rightY, shippingY) + 3;
    const boxHeight = headerBottomY - boxStartY;
    doc.setDrawColor(BORDER_COLOR);
    doc.rect(MARGIN_LEFT, boxStartY, pageW - 2 * PADDING, boxHeight);

    doc.line(col1, boxStartY, col1, headerBottomY);

    doc.line(col2, boxStartY, col2, headerBottomY);

    if (hasShipping) {
      doc.line(col3, boxStartY, col3, headerBottomY);
    }
    // Draw the Table
    autoTable(doc, {
      startY: headerBottomY,
      theme: "grid",
      margin: { left: PADDING, right: PADDING, top: PADDING, bottom: PADDING },
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 8,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        textColor: "#041121",
        lineColor: BORDER_COLOR,
        lineWidth: BORDER_WIDTH,
      },
      headStyles: {
        font: "Inter-Bold",
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineWidth: BORDER_WIDTH,
        // lineWidth: { top: 0, bottom: 0.5, left: 0.1, right: 0.1 },
      },
      columnStyles: {
        0: { cellWidth: 12, halign: "center" },
        1: { cellWidth: "auto", overflow: "ellipsize" },
        2: { cellWidth: 20, halign: "right" },
        3: { cellWidth: 20, halign: "right" },
        4: { cellWidth: 15, halign: "right" },
        5: { cellWidth: 25, halign: "right" },
        6: { cellWidth: 25, halign: "right" },
        7: { cellWidth: 20, halign: "right" },
      },
      head: [
        [
          "#",
          "Item",
          "HSN/SAC",
          "Price",
          "Qty",
          "Taxable Value",
          "Tax Amount",
          "Amount",
        ],
      ],
      //   body: globalData.saleitems.flatMap((it, i) =>
      //   Array.from({ length: 13 }).map((_, j) => [
      //     i * 5 + j + 1,
      //     { content: `${it.title}\n${it.notes || ""}` },
      //     it.hsnsac,
      //     formatCurrency(CurrencyConverter.toCurrency(it.baseprice || 0, "INR"), "INR", true, true),
      //     it.quantity,
      //     formatCurrency(CurrencyConverter.toCurrency(it.lineTotalBasePrice || 0, "INR"), "INR", true, true),
      //     formatCurrency(CurrencyConverter.toCurrency(it.lineTotalTaxAmount || 0, "INR"), "INR", true, true),
      //     formatCurrency(CurrencyConverter.toCurrency(it.lineGrandTotal || 0, "INR"), "INR", true, true),
      //   ])
      // ),
      body: globalData.saleitems.map((it, i) => [
        i + 1,
        {
          content: it?.note ? `${it.title}\n${it.note}` : it.title,
          styles: { overflow: "linebreak" },
        },

        it.hsnsac,
        `₹${it.baseprice}`,
        `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`,
        `₹${it.lineTotalBasePrice}`,
        `₹${it.lineTotalTaxAmount}`,
        `₹${it.lineGrandTotal}`,
      ]),
      didParseCell: function (globalData) {
        globalData.cell.styles.lineColor = BORDER_COLOR;

        if (globalData.section === "head") {
          const colId = globalData.column.index;
          const hasItems = data?.saleitems?.length > 0;
          if (colId === 0) globalData.cell.styles.halign = "center";
          if ([2, 3, 4, 5, 6, 7, 8].includes(colId))
            globalData.cell.styles.halign = "right";
          if (hasItems) {
            globalData.cell.styles.lineWidth = {
              top: BORDER_WIDTH,
              bottom: 1,
              left: BORDER_WIDTH,
              right: BORDER_WIDTH,
            };
          }
        }
        if (globalData.section === "body") {
          const isLastRow =
            globalData.row.index === globalData.table.body.length - 1;
          globalData.cell.styles.lineWidth = {
            top: 0,
            bottom: isLastRow ? 0.1 : 0,
            left: 0.1,
            right: 0.1,
          };
        }
      },
      didDrawPage: function (data) {
        if (data.cursor && data.cursor.y) {
          doc.setDrawColor(BORDER_COLOR);
          doc.setLineWidth(0.1);
          doc.line(
            data.settings.margin.left,
            data.cursor.y,
            doc.internal.pageSize.width - data.settings.margin.right,
            data.cursor.y,
          );
        }
      },
    });

    const footerStartY = doc.lastAutoTable.finalY;

    const summaryText = `Total amount (in words):`;
    const amountWords = `${globalData?.amountinwords || ""}`;
    const bankInfo = [
      [
        "Name:",
        storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "",
      ],
      [
        "Account #:",
        storeSettings?.paymentSettings?.bankDetails?.accountNo || "",
      ],
      ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
    ];
    let summaryY = doc.lastAutoTable.finalY;
    const bankRows = storeSettings?.paymentSettings?.bankDetails
      ? bankInfo.length
      : 0;

    const summaryHeight =
      5 + // top gap
      4 + // amount words
      6 + // spacing
      bankRows * 4 + // bank rows
      8 + // UPI
      35; // QR + summary table safety

    if (summaryY + summaryHeight > pageH - PADDING) {
      doc.addPage();
      summaryY = PADDING; // New top position
      boxStartY = summaryY; // <--- ADD THIS LINE: Resets the rectangle anchor
    }
    doc.setFontSize(8);
    doc.setFont("Inter-Bold", "bold");
    let footerY = summaryY + 5;
    doc.text(summaryText, PADDING + 2, footerY);
    footerY += 4;
    doc.setFont("Inter-Regular", "normal");
    doc.text(amountWords, PADDING + 2, footerY);

    footerY += 6;
    doc.setFont("Inter-Bold", "bold");
    if (storeSettings?.paymentSettings?.bankDetails && optData?.isBankDetails) {
      doc.text("Bank Details:", PADDING + 2, footerY);
      doc.setFont("Inter-Regular", "normal");
      footerY += 4;
      bankInfo.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, PADDING + 2, footerY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(String(value || ""), PADDING + 20, footerY);
        footerY += 4;
        // doc.text(`${label} ${value}`, PADDING + 2, footerY);
      });
    }
    const upiId = storeSettings?.paymentSettings?.upiId || "";
    const QRSIZE = optData?.isBankDetails ? 28 : 0;
    if (optData?.isBankDetails) {
      doc.setFontSize(8);
      footerY += 3;
      if (upiId) {
        doc.text(`UPI ID: ${upiId}`, PADDING + 2, footerY, { align: "left" });
      }
      // 4. QR Code Section (Center)

      if (upiId && upiId.trim() !== "") {
        const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
          storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "",
        )}&cu=INR`;
        const qrX = pageW / 2 - 10;
        const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
          errorCorrectionLevel: "L",
          scale: 4,
          margin: 1,
        });
        doc.addImage(qrCodeDataUrl, "JPEG", qrX, summaryY + 10, QRSIZE, QRSIZE);
      }
    }
    // 5. Right Side: Financial Summary (Taxable, Tax, Total)
    const finalSummaryX = hasShipping ? col2 + 2 : col2 - 20; // Align with the right-most vertical line
    let rightSummaryY = summaryY;
    const summaryWidth = pageW - PADDING - finalSummaryX;
    const rowHeight = 6;
    const paidamount =
      (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);

    const rows = [
      ["Taxable Amount", `₹${globalData?.totalbaseprice}`],
      ["Total Tax", `₹${globalData?.totaltaxamount}`],
      ["Total", `₹${globalData?.grandtotal}`],
      ["Amount Payable", `₹${globalData?.balanceDue}`],
      ["Amount Paid", `₹${paidamount.toFixed(2)}`],
    ];

    const tableHeight = rows.length * rowHeight;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    let y = rightSummaryY;

    rows.forEach((row, i) => {
      const textY = y + rowHeight / 2 + 1.5;
      if (row[0] === "Amount Paid") {
        doc.setFont("Inter-Regular", "normal");

        doc.setDrawColor(BORDER_COLOR);
        const centeredText = `${row[0]} : ${row[1]}`;
        const boxCenterX = finalSummaryX + summaryWidth / 2;
        doc.text(centeredText, boxCenterX, textY, { align: "center" });
        doc.setTextColor(0, 0, 0);
      } else {
        if (row[0] === "Amount Payable") {
          doc.setFont("Inter-Bold", "bold");
        } else {
          doc.setFont("Inter-Regular", "normal");
          doc.setDrawColor(BORDER_COLOR);
        }

        doc.text(row[0], finalSummaryX + 2, textY, { align: "left" });
        doc.text(row[1], finalSummaryX + summaryWidth - 2, textY, {
          align: "right",
        });
      }
      if (i !== rows.length - 1) {
        doc.line(
          finalSummaryX,
          y + rowHeight,
          finalSummaryX + summaryWidth,
          y + rowHeight,
        );
      }

      y += rowHeight;
    });
    doc.setFont("Inter-Regular", "normal");
    const qrBottomY = upiId ? summaryY + 10 + QRSIZE : summaryY;
    const tableBottomY = y;

    const finalFooterY = Math.max(footerY, tableBottomY, qrBottomY) + 5;
    doc.setDrawColor(BORDER_COLOR);
    doc.setTextColor(0, 0, 0);

    doc.rect(PADDING, boxStartY, pageW - PADDING * 2, finalFooterY - boxStartY);

    doc.line(finalSummaryX, rightSummaryY, finalSummaryX, finalFooterY);

    //     // // 6. BOTTOM SECTION: 3 Sections ( Terms)

    const rawTerms = terms || "";
    const footerWidth = pageW * PADDING;
    const termLines = doc.splitTextToSize(rawTerms, footerWidth);
    const termsHeight = termLines.length * 3.5 + 10;

    const sigSectionHeight = 30;
    let currentY = finalFooterY;

    if (optData?.isRemark && globalData?.remark) {
      const remarkLines = doc.splitTextToSize(
        globalData.remark.charAt(0).toUpperCase() + globalData.remark.slice(1),
        pageW - PADDING * 2 - 4,
      );

      // Calculate total height needed: 8 units for heading/spacing + 4 units per line
      const remarkHeight = 8 + remarkLines.length * 4;

      // Page break check
      if (currentY + remarkHeight > pageH - PADDING) {
        doc.addPage();
        currentY = PADDING;
      }

      // 1. Draw Remark Box
      doc.rect(PADDING, currentY, pageW - PADDING * 2, remarkHeight);

      // 2. Heading text
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Remark", PADDING + 2, currentY + 5);

      // 3. Remark Body Text
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8);

      let textY = currentY + 10; // Sets baseline safely below the heading

      remarkLines.forEach((line) => {
        if (textY > pageH - PADDING) {
          doc.addPage();
          textY = PADDING + 6;
        }
        doc.text(line, PADDING + 2, textY);
        textY += 4;
      });

      // 4. Update currentY perfectly to the bottom of this box
      currentY += remarkHeight;
    }
    const isNewPageNeeded =
      currentY + termsHeight + sigSectionHeight > pageH - PADDING;
    if (rawTerms.trim() !== "") {
      // ✅ DRAW MAIN BORDER ONLY TILL CORRECT END
      if (isNewPageNeeded) {
        // doc.rect(
        //   PADDING,
        //   boxStartY,
        //   pageW - PADDING * 2,
        //   finalFooterY - boxStartY
        // );
        doc.addPage();
        currentY = PADDING;
        const termsStartY = currentY;

        doc.rect(PADDING, termsStartY, pageW - PADDING * 2, termsHeight);
      } else {
        doc.rect(
          PADDING,
          boxStartY,
          pageW - PADDING * 2,
          currentY + termsHeight - boxStartY,
        );
      }

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Terms and Conditions:", PADDING + 2, currentY + 5);
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      termLines.forEach((line, i) => {
        doc.text(line, PADDING + 2, currentY + 10 + i * 3.5);
      });
      currentY += termsHeight;
    }
    doc.setDrawColor(...BORDER_COLOR);
    doc.setLineWidth(BORDER_WIDTH);
    // doc.line(PADDING, currentY, pageW - PADDING, currentY);
    doc.setFontSize(7);
    const totalFinalY = currentY + sigSectionHeight;
    doc.setDrawColor(...BORDER_COLOR);
    doc.setLineWidth(BORDER_WIDTH);
    const x = PADDING;
    y = currentY;
    const w = pageW - PADDING * 2;
    const h = sigSectionHeight - 8;
    doc.line(x, y, x, y + h);
    doc.line(x + w, y, x + w, y + h);
    doc.line(x, y + h, x + w, y + h);
    // doc.rect(PADDING, currentY,pageW - PADDING * 2, sigSectionHeight-8);
    const sigLineY = currentY + sigSectionHeight - 15;
    doc.line(PADDING + 2, sigLineY, PADDING + 35, sigLineY);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.text("Receiver's Signature", PADDING + 2, sigLineY + 4);
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(7);
    doc.text(
      `For ${globalData?.salefrom?.title}`,
      pageW - PADDING - 2,
      currentY + 5,
      { align: "right" },
    );
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 25; // Adjusted for smaller box
        const maxHeight = 10;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          "PNG",
          pageW - PADDING - imgW,
          sigLineY - imgH,
          imgW,
          imgH,
        );
      } catch (e) {
        doc.line(pageW - PADDING - 40, sigLineY, pageW - PADDING - 2, sigLineY);
      }
    } else {
      doc.line(pageW - PADDING - 45, sigLineY, pageW - PADDING - 2, sigLineY);
    }
    doc.text("Authorized Signatory", pageW - PADDING - 2, sigLineY + 4, {
      align: "right",
    });

    if (storeSettings?.negobillBranding) {
      const brandingY = totalFinalY - 3;
      doc.setFontSize(8);
      const normalText = "Powered By ";
      const boldText = "NegoBill.com";
      const normalWidth = doc.getTextWidth(normalText);
      const boldWidth = doc.getTextWidth(boldText);
      const startX = (pageW - (normalWidth + boldWidth)) / 2;

      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX, brandingY);
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX + normalWidth, brandingY);
    }
    doc.setDrawColor(...BORDER_COLOR);
    doc.setLineWidth(BORDER_WIDTH);
    setDownload(false);

    return doc;
  };

  const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const PADDING = 5;
    let boxStartY = 10;
    const BORDER_COLOR = selectedTheme?.templateTheme?.borderColor || "#000000"; // pure black
    const BORDER_WIDTH = 0.1;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const hasShipping =
      globalData.saleto?.shippingAddress &&
      optData.isCustomerDisplay &&
      (globalData?.saleto?.shippingAddress?.addressline1 ||
        globalData?.saleto?.shippingAddress?.addressline2);

    // ===== TITLE =====
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("BILL RECEIPT ", pageW / 2, 8, { align: "center" });

    // Define column split points
    const col1 = hasShipping ? PADDING + 70 : PADDING + 80;
    const col2 = hasShipping ? PADDING + 128 : PADDING + 145; // Slightly adjusted for better spacing
    const col3 = hasShipping ? PADDING + 162 : PADDING + 145;

    // Initialize Y trackers for each column
    let leftY = boxStartY + 4;
    let centerY = boxStartY + 4;
    let shippingY = boxStartY + 4;
    let rightY = boxStartY + 4;

    // ==============================
    // LEFT SECTION (Company)
    // ==============================
    if (globalData?.salefrom?.image) {
      try {
        const imagePath =
          uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 20;
        const maxHeight = 15;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalWidth = width * ratio;
        const finalHeight = height * ratio;
        // Use leftY as reference
        doc.addImage(
          base64,
          "PNG",
          MARGIN_LEFT + 2,
          leftY - 2,
          finalWidth,
          finalHeight,
        );
      } catch {
        doc.text("LOGO", MARGIN_LEFT + 2, leftY + 5);
      }
    }

    const leftX = 24;
    const availableWidth = col1 - (MARGIN_LEFT + leftX) - 2;
    doc.setFontSize(7.2);
    doc.setFont("Inter-Bold", "bold");
    const companyTitleLines = doc.splitTextToSize(
      globalData?.salefrom?.title || "",
      availableWidth,
    );

    companyTitleLines.forEach((line) => {
      doc.text(line, MARGIN_LEFT + leftX, leftY);
      leftY += 3.5;
    });

    const fromAddress = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode,
    );
    doc.setFont("Inter-Regular", "normal");
    const fromAddrLines = doc.splitTextToSize(fromAddress, availableWidth); // Wrapped size
    doc.text(fromAddrLines, MARGIN_LEFT + leftX, leftY);
    leftY += fromAddrLines.length * 4;
    leftY -= 1;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Mobile", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.phone || ""}`,
      MARGIN_LEFT + leftX + 10,
      leftY,
    );

    leftY += 3;

    // Email
    doc.setFont("Inter-Bold", "bold");
    doc.text("Email", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.email || ""}`,
      MARGIN_LEFT + leftX + 8,
      leftY,
    );

    let centerX = col1 + 2;
    let centerValueX = col2 - 2;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(7.5);
    doc.text(
      `Customer Details:${
        globalData.saleto && optData.isCustomerDisplay ? "" : "-"
      }`,
      centerX,
      centerY,
    );
    centerY += 4;
    doc.setFont("Inter-Regular", "normal");
    if (globalData.saleto && optData.isCustomerDisplay) {
      const name = globalData?.saleto?.name || "";
      const nameWidth = col2 - centerX - 2;
      const nameLines = doc.splitTextToSize(name, nameWidth);
      if (name) {
        nameLines.forEach((line) => {
          doc.text(line, centerX, centerY);
          centerY += 3.5;
        });
      }
      doc.setFont("Inter-Regular", "normal");
      const custAddress = [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
        globalData?.saleto?.pincode,
      ]
        .filter(Boolean)
        .join(", ");
      const custAddrLines = doc.splitTextToSize(custAddress, 55);
      doc.text(custAddrLines, centerX, centerY);
      centerY += custAddrLines.length * 4;
      centerY -= 1;
      const contactInfo = `Ph: ${globalData?.saleto?.phone || ""}`;
      if (globalData?.saleto?.phone || globalData?.saleto?.gstnumber) {
        centerY += 1;
        doc.text(contactInfo, centerX, centerY);
      }
      if (globalData?.saleto?.email) {
        centerY += 4;
        doc.text(`Email ${globalData?.saleto?.email || ""}`, centerX, centerY);
      }
      if (globalData?.saleto?.referenceid) {
        centerY += 4;
        doc.text(
          `Reference No: ${globalData?.saleto?.referenceid || ""}`,
          centerX,
          centerY,
        );
      }
      if (globalData?.saleto?.fssai) {
        centerY += 4;
        doc.text(`FASSI: ${globalData?.saleto?.fssai || ""}`, centerX, centerY);
      }
      if (globalData?.saleto?.pannumber) {
        centerY += 4;
        doc.text(
          `PAN: ${globalData?.saleto?.pannumber || ""}`,
          centerX,
          centerY,
        );
      }
      if (globalData?.saleto?.cinnumber) {
        centerY += 4;
        doc.text(
          `CIN: ${globalData?.saleto?.cinnumber || ""}`,
          centerX,
          centerY,
        );
      }
      if (globalData?.saleto?.state) {
        centerY += 4;
        doc.setFont("Inter-Bold", "bold");
        doc.text("Place of Supply:", centerX, centerY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(globalData?.saleto?.state || "", centerValueX, centerY, {
          align: "right",
        });
      }
    }
    if (hasShipping) {
      // ==============================
      // NEW SECTION (Shipping Details)
      // ==============================
      let shipX = col2 + 2;
      const shipWidth = col3 - shipX - 2;
      doc.setFont("Inter-Bold", "bold");
      doc.text("Shipping Details:", shipX, shippingY);
      shippingY += 4;
      doc.setFont("Inter-Regular", "normal");

      // Fetching shipping information from dataset
      const shippingAddress = [
        globalData?.saleto?.shippingAddress?.addressline1,
        globalData?.saleto?.shippingAddress?.addressline2,
        globalData?.saleto?.shippingAddress?.district,
        globalData?.saleto?.shippingAddress?.state,
        globalData?.saleto?.shippingAddress?.pincode,
      ]
        .filter(Boolean)
        .join(", ");

      const shipAddrLines = doc.splitTextToSize(shippingAddress, shipWidth);
      doc.text(shipAddrLines, shipX, shippingY);
      shippingY += shipAddrLines.length * 3.5;
    }

    let labelX = col3 + 2;
    let valueX = pageW - PADDING - 2; // The rightmost edge

    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill #:", labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleno || "", valueX, rightY, { align: "right" });

    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill Date:", labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      DateConverter.ISOToDisplayFormat(globalData?.saledate).date || "",
      valueX,
      rightY,
      { align: "right" },
    );

    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill Time:", labelX, rightY);
    const invDateTime = DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone),
    ).time;
    doc.setFont("Inter-Regular", "normal");
    doc.text(invDateTime || "", valueX, rightY, { align: "right" });
    const headerBottomY = Math.max(leftY, centerY, rightY, shippingY) + 3;
    const boxHeight = headerBottomY - boxStartY;
    doc.setDrawColor(BORDER_COLOR);
    doc.rect(MARGIN_LEFT, boxStartY, pageW - 2 * PADDING, boxHeight);
    doc.line(col1, boxStartY, col1, headerBottomY);
    doc.line(col2, boxStartY, col2, headerBottomY);
    if (hasShipping) {
      doc.line(col3, boxStartY, col3, headerBottomY);
    }
    // Draw the Table
    autoTable(doc, {
      startY: headerBottomY,
      theme: "grid",
      margin: { left: PADDING, right: PADDING, top: PADDING, bottom: PADDING },
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 8,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        textColor: "#041121",
        lineColor: BORDER_COLOR,
        lineWidth: BORDER_WIDTH,
      },
      headStyles: {
        font: "Inter-Bold",
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineWidth: BORDER_WIDTH,
        // lineWidth: { top: 0, bottom: 0.5, left: 0.1, right: 0.1 },
      },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: "auto" },
        2: { cellWidth: 20, halign: "right" },
        3: { cellWidth: 25, halign: "right" },
        4: { cellWidth: 25, halign: "right" },
        5: { cellWidth: 15, halign: "right" },
        6: { cellWidth: 20, halign: "right" },
      },
      head: [["#", "Item", "HSN/SAC", "Price", "MRP", "Qty", "Amount"]],

      body: globalData.saleitems.map((it, i) => [
        i + 1,
        {
          content: it?.note ? `${it.title}\n${it.note}` : it.title,
          styles: { overflow: "linebreak" },
        },
        it.hsnsac,
        `₹${it.baseprice}`,
        `₹${it.mrp}`,
        `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`,
        `₹${it.lineGrandTotal}`,
      ]),
      didParseCell: function (globalData) {
        globalData.cell.styles.lineColor = BORDER_COLOR;
        const hasItems = data?.saleitems?.length > 0;
        if (globalData.section === "head") {
          const colId = globalData.column.index;
          if (colId === 0) globalData.cell.styles.halign = "left";
          if ([2, 3, 4, 5, 6, 7].includes(colId))
            globalData.cell.styles.halign = "right";
          if (hasItems) {
            console.log("greater");
            globalData.cell.styles.lineWidth = {
              top: BORDER_WIDTH,
              bottom: 1,
              left: BORDER_WIDTH,
              right: BORDER_WIDTH,
            };
          }
        }
        if (globalData.section === "body") {
          const isLastRow =
            globalData.row.index === globalData.table.body.length - 1;
          globalData.cell.styles.lineWidth = {
            top: 0,
            bottom: isLastRow ? 0.1 : 0,
            left: 0.1,
            right: 0.1,
          };
        }
      },
      didDrawPage: function (data) {
        if (data.cursor && data.cursor.y) {
          doc.setDrawColor(BORDER_COLOR);
          doc.setLineWidth(0.1);
          doc.line(
            data.settings.margin.left,
            data.cursor.y,
            doc.internal.pageSize.width - data.settings.margin.right,
            data.cursor.y,
          );
        }
      },
    });

    const footerStartY = doc.lastAutoTable.finalY;

    const summaryText = `Total amount (in words):`;
    const amountWords = `${globalData?.amountinwords || ""}`;
    const bankInfo = [
      [
        "Name:",
        storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "",
      ],
      [
        "Account #:",
        storeSettings?.paymentSettings?.bankDetails?.accountNo || "",
      ],
      ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
    ];
    let summaryY = doc.lastAutoTable.finalY;
    const bankRows = storeSettings?.paymentSettings?.bankDetails
      ? bankInfo.length
      : 0;

    const summaryHeight =
      5 + // top gap
      4 + // amount words
      6 + // spacing
      bankRows * 4 + // bank rows
      8 + // UPI
      35; // QR + summary table safety

    if (summaryY + summaryHeight > pageH - PADDING) {
      doc.addPage();
      summaryY = PADDING; // New top position
      boxStartY = summaryY; // <--- ADD THIS LINE: Resets the rectangle anchor
    }
    doc.setFontSize(8);
    doc.setFont("Inter-Bold", "bold");
    let footerY = summaryY + 5;
    doc.text(summaryText, PADDING + 2, footerY);
    footerY += 4;
    doc.setFont("Inter-Regular", "normal");
    doc.text(amountWords, PADDING + 2, footerY);

    footerY += 6;
    doc.setFont("Inter-Bold", "bold");
    if (storeSettings?.paymentSettings?.bankDetails && optData?.isBankDetails) {
      doc.text("Bank Details:", PADDING + 2, footerY);
      doc.setFont("Inter-Regular", "normal");
      footerY += 4;
      bankInfo.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, PADDING + 2, footerY);
        doc.setFont("Inter-Regular", "normal");
        doc.text(String(value || ""), PADDING + 20, footerY);
        footerY += 4;
        // doc.text(`${label} ${value}`, PADDING + 2, footerY);
      });
    }
    const upiId = storeSettings?.paymentSettings?.upiId || "";
    const QRSIZE = optData?.isBankDetails ? 28 : 0;

    if (optData?.isBankDetails) {
      doc.setFontSize(8);
      footerY += 3;
      if (upiId) {
        doc.text(`UPI ID: ${upiId}`, PADDING + 2, footerY, { align: "left" });
      }
      // 4. QR Code Section (Center)

      if (upiId && upiId.trim() !== "") {
        const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
          storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "",
        )}&cu=INR`;
        const qrX = pageW / 2 - 10;
        const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
          errorCorrectionLevel: "L",
          scale: 4,
          margin: 1,
        });
        doc.addImage(qrCodeDataUrl, "JPEG", qrX, summaryY + 10, QRSIZE, QRSIZE);
      }
    }
    // 5. Right Side: Financial Summary (Taxable, Tax, Total)
    const finalSummaryX = col2 - 20; // Align with the right-most vertical line
    let rightSummaryY = summaryY;
    const summaryWidth = pageW - PADDING - finalSummaryX;
    const rowHeight = 6;
    const paidamount =
      (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);

    const rows = [
      // ["Taxable Amount", `₹${globalData?.totalbaseprice}`],
      // ["Total Tax", `₹${globalData?.totaltaxamount}`],
      ["Total", `₹${globalData?.grandtotal}`],
      ["Amount Payable", `₹${globalData?.balanceDue}`],
      ["Amount Paid", `₹${paidamount.toFixed(2)}`],
    ];

    const tableHeight = rows.length * rowHeight;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    let y = rightSummaryY;

    rows.forEach((row, i) => {
      const textY = y + rowHeight / 2 + 1.5;
      if (row[0] === "Amount Paid") {
        doc.setFont("Inter-Regular", "normal");

        doc.setDrawColor(BORDER_COLOR);
        const centeredText = `${row[0]} : ${row[1]}`;
        const boxCenterX = finalSummaryX + summaryWidth / 2;
        doc.text(centeredText, boxCenterX, textY, { align: "center" });
        doc.setTextColor(0, 0, 0);
      } else {
        if (row[0] === "Amount Payable") {
          doc.setFont("Inter-Bold", "bold");
        } else {
          doc.setFont("Inter-Regular", "normal");
          doc.setDrawColor(BORDER_COLOR);
        }

        doc.text(row[0], finalSummaryX + 2, textY, { align: "left" });
        doc.text(row[1], finalSummaryX + summaryWidth - 2, textY, {
          align: "right",
        });
      }
      if (i !== rows.length - 1) {
        doc.line(
          finalSummaryX,
          y + rowHeight,
          finalSummaryX + summaryWidth,
          y + rowHeight,
        );
      }

      y += rowHeight;
    });
    doc.setFont("Inter-Regular", "normal");
    const qrBottomY = upiId ? summaryY + 10 + QRSIZE : summaryY;
    const tableBottomY = y;

    const finalFooterY = Math.max(footerY, tableBottomY, qrBottomY) + 5;
    doc.setDrawColor(BORDER_COLOR);
    doc.setTextColor(0, 0, 0);

    doc.rect(PADDING, boxStartY, pageW - PADDING * 2, finalFooterY - boxStartY);

    doc.line(finalSummaryX, rightSummaryY, finalSummaryX, finalFooterY);

    //     // // 6. BOTTOM SECTION: 3 Sections ( Terms)

    const rawTerms = terms || "";
    const footerWidth = pageW * PADDING;
    const termLines = doc.splitTextToSize(rawTerms, footerWidth);
    const termsHeight = termLines.length * 3.5 + 10;

    const sigSectionHeight = 30;
    let currentY = finalFooterY;
    if (optData?.isRemark && globalData?.remark) {
      const remarkLines = doc.splitTextToSize(
        globalData.remark.charAt(0).toUpperCase() + globalData.remark.slice(1),
        pageW - PADDING * 2 - 4,
      );

      // Calculate total height needed: 8 units for heading/spacing + 4 units per line
      const remarkHeight = 8 + remarkLines.length * 4;

      // Page break check
      if (currentY + remarkHeight > pageH - PADDING) {
        doc.addPage();
        currentY = PADDING;
      }

      // 1. Draw Remark Box
      doc.rect(PADDING, currentY, pageW - PADDING * 2, remarkHeight);

      // 2. Heading text
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Remark", PADDING + 2, currentY + 5);

      // 3. Remark Body Text
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8);

      let textY = currentY + 10; // Sets baseline safely below the heading

      remarkLines.forEach((line) => {
        if (textY > pageH - PADDING) {
          doc.addPage();
          textY = PADDING + 6;
        }
        doc.text(line, PADDING + 2, textY);
        textY += 4;
      });

      // 4. Update currentY perfectly to the bottom of this box
      currentY += remarkHeight;
    }
    const isNewPageNeeded =
      currentY + termsHeight + sigSectionHeight > pageH - PADDING;
    if (rawTerms.trim() !== "") {
      // ✅ DRAW MAIN BORDER ONLY TILL CORRECT END
      if (isNewPageNeeded) {
        // doc.rect(
        //   PADDING,
        //   boxStartY,
        //   pageW - PADDING * 2,
        //   finalFooterY - boxStartY
        // );
        doc.addPage();
        currentY = PADDING;
        const termsStartY = currentY;

        doc.rect(PADDING, termsStartY, pageW - PADDING * 2, termsHeight);
      } else {
        doc.rect(
          PADDING,
          boxStartY,
          pageW - PADDING * 2,
          currentY + termsHeight - boxStartY,
        );
      }

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Terms and Conditions:", PADDING + 2, currentY + 5);
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      termLines.forEach((line, i) => {
        doc.text(line, PADDING + 2, currentY + 10 + i * 3.5);
      });
      currentY += termsHeight;
    }
    doc.setDrawColor(...BORDER_COLOR);
    doc.setLineWidth(BORDER_WIDTH);
    // doc.line(PADDING, currentY, pageW - PADDING, currentY);
    doc.setFontSize(7);
    const totalFinalY = currentY + sigSectionHeight;
    doc.setDrawColor(...BORDER_COLOR);
    doc.setLineWidth(BORDER_WIDTH);
    const x = PADDING;
    y = currentY;
    const w = pageW - PADDING * 2;
    const h = sigSectionHeight - 8;
    doc.line(x, y, x, y + h);
    doc.line(x + w, y, x + w, y + h);
    doc.line(x, y + h, x + w, y + h);
    // doc.rect(PADDING, currentY,pageW - PADDING * 2, sigSectionHeight-8);
    const sigLineY = currentY + sigSectionHeight - 15;
    doc.line(PADDING + 2, sigLineY, PADDING + 35, sigLineY);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.text("Receiver's Signature", PADDING + 2, sigLineY + 4);
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(7);
    doc.text(
      `For ${globalData?.salefrom?.title}`,
      pageW - PADDING - 2,
      currentY + 5,
      { align: "right" },
    );
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 25; // Adjusted for smaller box
        const maxHeight = 10;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          "PNG",
          pageW - PADDING - imgW,
          sigLineY - imgH,
          imgW,
          imgH,
        );
      } catch (e) {
        doc.line(pageW - PADDING - 40, sigLineY, pageW - PADDING - 2, sigLineY);
      }
    } else {
      doc.line(pageW - PADDING - 45, sigLineY, pageW - PADDING - 2, sigLineY);
    }
    doc.text("Authorized Signatory", pageW - PADDING - 2, sigLineY + 4, {
      align: "right",
    });

    if (storeSettings?.negobillBranding) {
      const brandingY = totalFinalY - 3;
      doc.setFontSize(8);
      const normalText = "Powered By ";
      const boldText = "NegoBill.com";
      const normalWidth = doc.getTextWidth(normalText);
      const boldWidth = doc.getTextWidth(boldText);
      const startX = (pageW - (normalWidth + boldWidth)) / 2;

      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX, brandingY);
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX + normalWidth, brandingY);
    }
    doc.setDrawColor(...BORDER_COLOR);
    doc.setLineWidth(BORDER_WIDTH);
    setDownload(false);

    return doc;
  };
  if (isReturnView) {
    return (
      <ReturnSaleInvoice
        isData={returnData} // This is the updated return sale data loaded by your hook
        selectedOption={selectedOption}
        onClose={handleClose}
        saleId={isData?._id}
        onDataUpdate={onDataUpdate}
        onDataChange={onDataChange}
        isActive={isActive}
      />
    );
  }
  return (
    <>
      <InvoiceModalLayout
        isOpen={isMainModalOpen}
        data={data}
        latestVersion={latestVersion}
        isBtnLoading={isBtnLoading}
        handleResetSale={handleResetSale}
        handleModeConfirm={handleModeConfirm}
        generateInvoice1={generateInvoice1}
        generateBill1={generateBill1}
        onClose={handleClose}
        {...invoiceData}
      >
        <InvoiceToggleActionCard
          optData={optData}
          setOptData={setOptData}
          setBilling={setBilling}
          setSelectTermalOption={setSelectTermalOption}
          setSelectHALFA4Option={setSelectHALFA4Option}
        />
        {saleLoading ? (
          <div
            className="d-flex justify-content-center"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            <CircularProgress size={20} className="text-primary" />
          </div>
        ) : (
          <div
            className="pt-2"
            style={{
              overflowY: "auto",
              width: "100%",
              maxHeight: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            {globalData?.salemode === "INVOICE" || isBillReceipt ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <div className="text-center fw-bold py-1 border-dark">
                            {documentTitle}
                          </div>
                          <div
                            className=""
                            style={{
                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          >
                            <div
                              className="row g-0 "
                              style={{
                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div
                                className={`col-${hasShipping ? 4 : 5}  d-flex pe-2`}
                                style={{
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <div className="ps-2 pe-2 pt-1">
                                  {globalData?.salefrom?.image && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        "profile/" +
                                        globalData?.salefrom?.image
                                      }
                                      className="img-rounded logo mb-0"
                                      height="45"
                                      width={hasShipping ? "75px" : "100px"}
                                      style={{ objectFit: "contain" }}
                                    />
                                  )}
                                </div>
                                <div
                                  className="font-11"
                                  style={{
                                    maxWidth: hasShipping ? "155px" : "190px",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  <div className="fw-bold font-10">
                                    {globalData.salefrom?.title}
                                  </div>
                                  {globalData?.salefrom?.gstnumber && (
                                    <div className="font-10">
                                      <strong>
                                        GSTIN {globalData?.salefrom?.gstnumber}
                                      </strong>
                                    </div>
                                  )}
                                  <div className="font-10">
                                    {globalData?.salefrom?.addressline1}{" "}
                                    {globalData?.salefrom?.addressline2}{" "}
                                    {globalData?.salefrom?.district}{" "}
                                    {globalData?.salefrom?.state}{" "}
                                    {globalData?.salefrom?.pincode}
                                  </div>
                                  <div className="font-10">
                                    <strong>Mobile</strong>{" "}
                                    {globalData?.salefrom?.phone}
                                  </div>
                                  <div className="font-10">
                                    <strong>Email</strong>{" "}
                                    {globalData?.salefrom?.email}
                                  </div>
                                </div>
                              </div>

                              <div
                                className={`col-${hasShipping ? 3 : 4} ps-2 pe-2   font-12`}
                                style={{
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <div className="fw-bold font-10">
                                  Customer Details:
                                  {globalData?.saleto &&
                                  optData.isCustomerDisplay
                                    ? ""
                                    : "-"}
                                </div>
                                {globalData.saleto &&
                                  optData.isCustomerDisplay && (
                                    <>
                                      <div className="font-10">
                                        {globalData.saleto?.name}
                                      </div>
                                      <div className="font-10">
                                        {globalData.saleto?.addressline1}{" "}
                                        {globalData.saleto?.addressline2}{" "}
                                        {globalData.saleto?.district}{" "}
                                        {globalData.saleto?.state}{" "}
                                        {globalData.saleto?.pincode}{" "}
                                      </div>
                                      {(globalData?.saleto?.phone ||
                                        globalData?.saleto?.gstnumber) && (
                                        <div className="font-10">
                                          Ph:
                                          {globalData?.saleto?.phone} | GSTIN:
                                          {globalData?.saleto?.gstnumber || "-"}
                                        </div>
                                      )}
                                      {globalData?.saleto?.email && (
                                        <div className="font-10">
                                          Email {globalData?.saleto?.email}
                                        </div>
                                      )}
                                      {globalData?.saleto?.referenceid && (
                                        <div className="font-10">
                                          Reference No:{" "}
                                          {globalData?.saleto?.referenceid ||
                                            ""}
                                        </div>
                                      )}
                                      {globalData.saleto?.fssai && (
                                        <div className="font-10">
                                          FASSI:{" "}
                                          {globalData.saleto?.fssai || ""}
                                        </div>
                                      )}
                                      {globalData.saleto?.pannumber && (
                                        <div className="font-10">
                                          PAN:{" "}
                                          {globalData.saleto?.pannumber || ""}
                                        </div>
                                      )}
                                      {globalData.saleto?.cinnumber && (
                                        <div className="font-10">
                                          CIN :
                                          {globalData?.saleto?.cinnumber || ""}
                                        </div>
                                      )}
                                      {globalData?.saleto?.state && (
                                        <div className="fw-bold  d-flex justify-content-between mb-1 font-11">
                                          Place of Supply:
                                          <span>
                                            {globalData?.saleto?.state || ""}
                                          </span>
                                        </div>
                                      )}
                                    </>
                                  )}
                              </div>
                              {hasShipping && (
                                <div
                                  className="col-3 ps-2 pe-2  font-10"
                                  style={{
                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div className="fw-bold font-10">
                                    Shipping Details:
                                  </div>
                                  <div className="font-10">
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.addressline1
                                    }{" "}
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.addressline2
                                    }{" "}
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.district
                                    }{" "}
                                    {
                                      globalData?.saleto?.shippingAddress
                                        ?.country
                                    }{" "}
                                    {globalData.saleto?.shippingAddress?.state}{" "}
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.pincode
                                    }{" "}
                                  </div>
                                  {globalData?.saleto?.shippingAddress
                                    ?.phone && (
                                    <div>
                                      Phone: +91{" "}
                                      {
                                        globalData?.saleto?.shippingAddress
                                          ?.phone
                                      }
                                    </div>
                                  )}
                                  {globalData?.saleto?.shippingAddress
                                    ?.email && (
                                    <div>
                                      Email:{" "}
                                      {
                                        globalData?.saleto?.shippingAddress
                                          ?.email
                                      }
                                    </div>
                                  )}
                                </div>
                              )}
                              <div
                                className={`col-${hasShipping ? 2 : 3} pe-2 ps-2 font-12`}
                              >
                                <div
                                  className={`d-flex justify-content-between  ${hasShipping ? "font-8-5 " : "font-11"}`}
                                >
                                  <strong>{invLabel}</strong>
                                  <span>{globalData.saleno}</span>
                                </div>
                                <div
                                  className={`d-flex justify-content-between  ${hasShipping ? "font-8-5 " : "font-11"}`}
                                >
                                  <strong>{invDate}</strong>
                                  <span>{saleTime.date}</span>
                                </div>
                                <div
                                  className={`d-flex justify-content-between  ${hasShipping ? "font-8-5 " : "font-11"}`}
                                >
                                  <strong>{invTime}</strong>
                                  <span>{saleTime.time}</span>
                                </div>
                              </div>
                            </div>

                            <table
                              className="invoice-table "
                              style={{
                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                              width="100%"
                            >
                              <thead>
                                <tr
                                  style={{
                                    borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <th
                                    className=" text-center text-black text-bold background_white   font-10 p-0 "
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    #
                                  </th>
                                  <th
                                    className="text-start  text-black text-bold background_white  font-10 p-0 ps-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Item
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    HSN/SAC
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Price
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0 ps-1  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Qty
                                  </th>

                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Taxable Value
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Tax Amount
                                  </th>
                                  <th
                                    className="text-end text-black text-bold  background_white  font-10 p-0  pe-1"
                                    style={{
                                      borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {globalData?.saleitems?.map((item, index) => (
                                  <tr key={index} className="font-10 align-top">
                                    <td
                                      className="text-center  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      className="text-start  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {item?.title}
                                      <div className="font-10">
                                        {item?.note}
                                      </div>
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {item?.hsnsac}
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹{item?.baseprice}
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {item?.quantity}
                                      <span className="font-11 ms-1">
                                        {(() => {
                                          const unitCode = item?.isSecondaryUnit
                                            ? item?.unitConfig
                                                ?.secondaryUnitCode
                                            : item?.unitConfig?.primaryUnitCode;

                                          // return unitCode !== "unit" ? unitCode : "";
                                          return unitCode || "";
                                        })()}
                                      </span>
                                    </td>

                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹{item?.lineTotalBasePrice}
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹{item?.lineTotalTaxAmount}
                                    </td>
                                    <td className="text-end p-1">
                                      ₹{item?.lineGrandTotal}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <div
                              className="row g-0  "
                              style={{
                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div
                                className="col-7 "
                                style={{
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <div className="p-2  border-dark font-11">
                                  <strong>Total amount (in words):</strong>
                                  <br />
                                  {globalData?.amountinwords}
                                </div>
                                <div className="row g-0">
                                  <div className="col-7 p-2 pt-0  border-dark font-11">
                                    {storeSettings?.paymentSettings
                                      ?.bankDetails &&
                                      optData?.isBankDetails && (
                                        <>
                                          <strong>Bank Details:</strong>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              Name:
                                            </span>

                                            {
                                              storeSettings?.paymentSettings
                                                ?.bankDetails?.beneficiaryName
                                            }
                                          </div>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              Account #:
                                            </span>

                                            {
                                              storeSettings?.paymentSettings
                                                ?.bankDetails?.accountNo
                                            }
                                          </div>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              IFSC:
                                            </span>

                                            {
                                              storeSettings?.paymentSettings
                                                ?.bankDetails?.ifsc
                                            }
                                          </div>
                                          <div className="mt-2 font-11">
                                            UPI ID:{" "}
                                            {
                                              storeSettings?.paymentSettings
                                                ?.upiId
                                            }
                                          </div>{" "}
                                        </>
                                      )}
                                  </div>
                                  {qrCodeDataUrl && optData?.isBankDetails && (
                                    <div className="col-5 d-flex align-items-center justify-content-end">
                                      <img
                                        src={qrCodeDataUrl}
                                        alt="QR"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="col-5">
                                {[
                                  {
                                    label: "Taxable Amount",
                                    value: globalData?.totalbaseprice,
                                  },
                                  {
                                    label: "Total Tax",
                                    value: globalData?.totaltaxamount,
                                  },
                                  {
                                    label: "Total",
                                    value: globalData?.grandtotal,
                                  },
                                  {
                                    label: "Amount Payable ",
                                    value: globalData?.balanceDue,
                                    bold: true,
                                  },
                                  {
                                    label: "Amount Paid",
                                    value: parseFloat(
                                      actualPaidAmount || 0,
                                    ).toFixed(2),
                                    noBorder: true,
                                    isGreen: true,
                                  },
                                ].map((row, i) => (
                                  <div
                                    key={i}
                                    className={`d-flex p-0 ps-1 pe-1 font-10 px-2 
                                    ${
                                      row.isGreen
                                        ? "justify-content-center"
                                        : "justify-content-between"
                                    } 
                                  `}
                                    style={{
                                      ...(!row.noBorder && {
                                        borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }),
                                    }}
                                    // style={{
                                    //   color: row.isGreen ? "#28a745" : "black",
                                    // }}
                                  >
                                    <span
                                      className={`${row.bold ? "fw-bold" : ""}`}
                                    >
                                      {row.label}
                                      {row.isGreen && (
                                        <span className="mx-1">:</span>
                                      )}
                                    </span>

                                    <span
                                      className={`${row.bold ? "fw-bold" : ""}`}
                                    >
                                      ₹{row.value}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {optData?.isRemark && globalData?.remark && (
                              <div className="row g-0 ">
                                <div
                                  className="col-12   p-2"
                                  style={{
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <table width="100%" className="">
                                    <tbody>
                                      <tr>
                                        <td width="100%">
                                          <div className="font-10 fw-600 align-left text-black ">
                                            Remark
                                          </div>

                                          <div className="font-9 lh-base">
                                            {capitalizeFirstLetter(
                                              globalData?.remark,
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                            {terms && (
                              <div className="row g-0 ">
                                <div
                                  className="col-12   p-2"
                                  style={{
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div className="fw-bold font-10 mb-0">
                                    Terms and Conditions:
                                  </div>
                                  <div
                                    className="font-9 text-muted lh-base"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                    }}
                                  >
                                    {terms}
                                  </div>
                                </div>
                              </div>
                            )}
                            <div
                              className="row g-0 "
                              style={{
                                borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div className="col-3 p-2 d-flex flex-column justify-content-end">
                                <div className="text-left">
                                  <div
                                    style={{
                                      borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      width: "120px",
                                    }}
                                  ></div>
                                  <div className="font-10 mt-1">
                                    Receiver's Signature
                                  </div>
                                </div>
                              </div>

                              <div className="col-9 p-2 d-flex flex-column justify-content-end text-end">
                                <div className="fw-bold font-8 mb-1">
                                  For {globalData?.salefrom?.title}
                                </div>

                                <div className="p-0 m-1 me-0">
                                  {storeSettings?.invoiceSettings?.signature ? (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings?.invoiceSettings
                                          ?.signature
                                      }
                                      alt="Signature"
                                      width="120"
                                      style={{ marginBottom: "-5px" }} // Slight overlap fix if needed
                                    />
                                  ) : (
                                    <>
                                      <div className="pt-4">
                                        <hr
                                          className="m-1 ms-auto me-0"
                                          style={{
                                            borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            maxWidth: "135px",
                                          }}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>

                                <div className="fw-bold font-10 pt-1">
                                  Authorized Signatory
                                </div>
                              </div>
                            </div>
                          </div>
                          {storeSettings?.negobillBranding && (
                            <div className="text-center mt-1 font-11">
                              Powered By <strong>NegoBill.com</strong>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : globalData.salemode === "BILL" ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <div className="text-center fw-bold py-1  border-dark">
                            BILL RECEIPT
                          </div>
                          <div
                            className=""
                            style={{
                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          >
                            <div
                              className="row g-0 "
                              style={{
                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div
                                className={`col-${hasShipping ? 4 : 5}  d-flex pe-2`}
                                style={{
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <div className="ps-2 pe-2 pt-1">
                                  {globalData?.salefrom?.image && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        "profile/" +
                                        globalData?.salefrom?.image
                                      }
                                      className="img-rounded logo mb-0"
                                      height="45"
                                      width={hasShipping ? "75px" : "100px"}
                                      style={{ objectFit: "contain" }}
                                    />
                                  )}
                                </div>
                                <div
                                  className="font-11"
                                  style={{
                                    maxWidth: hasShipping ? "155px" : "190px",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  <div className="fw-bold font-11">
                                    {globalData.salefrom?.title}
                                  </div>
                                  <div className="font-11">
                                    {globalData?.salefrom?.addressline1}{" "}
                                    {globalData?.salefrom?.addressline2}{" "}
                                    {globalData?.salefrom?.district}{" "}
                                    {globalData?.salefrom?.state}{" "}
                                    {globalData?.salefrom?.pincode}
                                  </div>
                                  <div className="font-11">
                                    <strong>Mobile</strong>{" "}
                                    {globalData?.salefrom?.phone}
                                  </div>
                                  <div className="font-11">
                                    <strong>Email</strong>{" "}
                                    {globalData?.salefrom?.email}
                                  </div>
                                </div>
                              </div>

                              <div
                                className={`col-${hasShipping ? 3 : 4} ps-2 pe-2  font-12`}
                                style={{
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <div className="fw-bold font-11">
                                  Customer Details:{" "}
                                  {globalData?.saleto &&
                                  optData?.isCustomerDisplay
                                    ? ""
                                    : "-"}
                                </div>
                                {globalData.saleto &&
                                  optData.isCustomerDisplay && (
                                    <>
                                      <div className="font-11">
                                        {globalData.saleto?.name}
                                      </div>
                                      <div className="font-11">
                                        {globalData.saleto?.addressline1}{" "}
                                        {globalData.saleto?.addressline2}{" "}
                                        {globalData.saleto?.district}{" "}
                                        {globalData.saleto?.state}{" "}
                                        {globalData.saleto?.pincode}{" "}
                                      </div>
                                      {globalData?.saleto?.phone && (
                                        <div className="font-11">
                                          Ph:
                                          {globalData?.saleto?.phone}
                                        </div>
                                      )}
                                      {globalData?.saleto?.email && (
                                        <div className="font-11">
                                          Email {globalData?.saleto?.email}
                                        </div>
                                      )}
                                      {globalData?.saleto?.referenceid && (
                                        <div className="font-10">
                                          Reference No:{" "}
                                          {globalData?.saleto?.referenceid ||
                                            ""}
                                        </div>
                                      )}
                                      {globalData.saleto?.fssai && (
                                        <div className="font-10">
                                          FASSI:{" "}
                                          {globalData.saleto?.fssai || ""}
                                        </div>
                                      )}
                                      {globalData.saleto?.pannumber && (
                                        <div className="font-10">
                                          PAN:{" "}
                                          {globalData.saleto?.pannumber || ""}
                                        </div>
                                      )}
                                      {globalData.saleto?.cinnumber && (
                                        <div className="font-10">
                                          CIN :
                                          {globalData?.saleto?.cinnumber || ""}
                                        </div>
                                      )}
                                      {globalData?.saleto?.state && (
                                        <div className="fw-bold  d-flex justify-content-between mb-1 font-11">
                                          Place of Supply:
                                          <span>
                                            {globalData?.saleto?.state || ""}
                                          </span>
                                        </div>
                                      )}
                                    </>
                                  )}
                              </div>
                              {hasShipping && (
                                <div
                                  className="col-3 ps-2 pe-2  font-10"
                                  style={{
                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div className="fw-bold font-10">
                                    Shipping Details:
                                  </div>
                                  <div className="font-10">
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.addressline1
                                    }{" "}
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.addressline2
                                    }{" "}
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.district
                                    }{" "}
                                    {
                                      globalData?.saleto?.shippingAddress
                                        ?.country
                                    }{" "}
                                    {globalData.saleto?.shippingAddress?.state}{" "}
                                    {
                                      globalData.saleto?.shippingAddress
                                        ?.pincode
                                    }{" "}
                                  </div>
                                  {globalData?.saleto?.shippingAddress
                                    ?.phone && (
                                    <div>
                                      Phone: +91{" "}
                                      {
                                        globalData?.saleto?.shippingAddress
                                          ?.phone
                                      }
                                    </div>
                                  )}
                                  {globalData?.saleto?.shippingAddress
                                    ?.email && (
                                    <div>
                                      Email:{" "}
                                      {
                                        globalData?.saleto?.shippingAddress
                                          ?.email
                                      }
                                    </div>
                                  )}
                                </div>
                              )}
                              <div
                                className={`col-${hasShipping ? 2 : 3} pe-2 ps-2 font-11`}
                              >
                                <div
                                  className={`d-flex justify-content-between  ${hasShipping ? "font-8-5 " : "font-11"}`}
                                >
                                  <strong>Bill #:</strong>
                                  <span>{globalData.saleno}</span>
                                </div>
                                <div
                                  className={`d-flex justify-content-between  ${hasShipping ? "font-8-5 " : "font-11"}`}
                                >
                                  <strong>Bill Date:</strong>
                                  <span>{saleTime.date}</span>
                                </div>
                                <div
                                  className={`d-flex justify-content-between  ${hasShipping ? "font-8-5 " : "font-11"}`}
                                >
                                  <strong>Bill Time:</strong>
                                  <span>{saleTime.time}</span>
                                </div>
                              </div>
                            </div>

                            <table
                              className="invoice-table "
                              width="100%"
                              style={{
                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <thead>
                                <tr
                                  style={{
                                    borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <th
                                    className=" text-center  text-black text-bold background_white   font-10 p-0 "
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    #
                                  </th>
                                  <th
                                    className="text-start  text-black text-bold background_white  font-10 p-0 ps-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Item
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    HSN/SAC
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Price
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    MRP
                                  </th>
                                  <th
                                    className="text-end  text-black text-bold background_white  font-10 p-0 ps-1  pe-1"
                                    style={{
                                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Qty
                                  </th>

                                  <th
                                    className="text-end text-black text-bold  background_white  font-10 p-0  pe-1"
                                    style={{
                                      borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    Amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {globalData?.saleitems?.map((item, index) => (
                                  <tr key={index} className="font-10 align-top">
                                    <td
                                      className="text-center   p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      className="text-start  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {item?.title}
                                      <div className="font-10">
                                        {item?.note}
                                      </div>
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {item?.hsnsac}
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹{item?.baseprice}
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹{item?.mrp}
                                    </td>
                                    <td
                                      className="text-end  p-1"
                                      style={{
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {item?.quantity}
                                      <span className="font-11 ms-1">
                                        {(() => {
                                          const unitCode = item?.isSecondaryUnit
                                            ? item?.unitConfig
                                                ?.secondaryUnitCode
                                            : item?.unitConfig?.primaryUnitCode;

                                          // return unitCode !== "unit" ? unitCode : "";
                                          return unitCode || "";
                                        })()}
                                      </span>
                                    </td>

                                    <td className="text-end p-1">
                                      ₹{item?.lineGrandTotal}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <div
                              className="row g-0 "
                              style={{
                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div
                                className="col-7 "
                                style={{
                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                <div className="p-2  border-dark font-11">
                                  <strong>Total amount (in words):</strong>
                                  <br />
                                  {globalData?.amountinwords}
                                </div>
                                <div className="row g-0">
                                  <div className="col-7 p-2 pt-0  border-dark font-11">
                                    {storeSettings?.paymentSettings
                                      ?.bankDetails &&
                                      optData?.isBankDetails && (
                                        <>
                                          <strong>Bank Details:</strong>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              Name:
                                            </span>

                                            {
                                              storeSettings?.paymentSettings
                                                ?.bankDetails?.beneficiaryName
                                            }
                                          </div>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              Account #:
                                            </span>

                                            {
                                              storeSettings?.paymentSettings
                                                ?.bankDetails?.accountNo
                                            }
                                          </div>
                                          <div className="d-flex font-11">
                                            <span style={{ width: "80px" }}>
                                              IFSC:
                                            </span>

                                            {
                                              storeSettings?.paymentSettings
                                                ?.bankDetails?.ifsc
                                            }
                                          </div>
                                          <div className="mt-2 font-11">
                                            UPI ID:{" "}
                                            {
                                              storeSettings?.paymentSettings
                                                ?.upiId
                                            }
                                          </div>{" "}
                                        </>
                                      )}
                                  </div>
                                  {qrCodeDataUrl && optData?.isBankDetails && (
                                    <div className="col-5 d-flex align-items-center justify-content-end">
                                      <img
                                        src={qrCodeDataUrl}
                                        alt="QR"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="col-5">
                                {[
                                  {
                                    label: "Total",
                                    value: globalData?.grandtotal,
                                  },
                                  {
                                    label: "Amount Payable ",
                                    value: globalData?.balanceDue,
                                    bold: true,
                                  },
                                  {
                                    label: "Amount Paid",
                                    value: parseFloat(
                                      actualPaidAmount || 0,
                                    ).toFixed(2),
                                    noBorder: true,
                                    isGreen: true,
                                  },
                                ].map((row, i) => (
                                  <div
                                    key={i}
                                    className={`d-flex p-0 ps-1 pe-1 font-10 px-2 
                                    ${
                                      row.isGreen
                                        ? "justify-content-center"
                                        : "justify-content-between"
                                    } 
                                   `}
                                    style={{
                                      ...(!row.noBorder && {
                                        borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }),
                                    }}
                                  >
                                    <span
                                      className={`${row.bold ? "fw-bold" : ""}`}
                                    >
                                      {row.label}
                                      {row.isGreen && (
                                        <span className="mx-1">:</span>
                                      )}
                                    </span>

                                    <span
                                      className={`${row.bold ? "fw-bold" : ""}`}
                                    >
                                      ₹{row.value}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {optData?.isRemark && globalData?.remark && (
                              <div className="row g-0 ">
                                <div
                                  className="col-12   p-2"
                                  style={{
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <table width="100%" className="">
                                    <tbody>
                                      <tr>
                                        <td width="100%">
                                          <div className="font-10 fw-600 align-left text-black ">
                                            Remark
                                          </div>

                                          <div className="font-9 lh-base">
                                            {capitalizeFirstLetter(
                                              globalData?.remark,
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                            {terms && (
                              <div className="row g-0 ">
                                <div
                                  className="col-12   p-2"
                                  style={{
                                    border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  <div className="fw-bold font-10 mb-0">
                                    Terms and Conditions:
                                  </div>
                                  <div
                                    className="font-9 text-muted lh-base"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                    }}
                                  >
                                    {terms}
                                  </div>
                                </div>
                              </div>
                            )}
                            <div
                              className="row g-0  "
                              style={{
                                borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              }}
                            >
                              <div className="col-3 p-2 d-flex flex-column justify-content-end">
                                <div className="text-left">
                                  <div
                                    style={{
                                      width: "120px",
                                      borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  ></div>
                                  <div className="font-10 mt-1">
                                    Receiver's Signature
                                  </div>
                                </div>
                              </div>

                              <div className="col-9 p-2 d-flex flex-column justify-content-end text-end">
                                <div className="fw-bold font-8 mb-1">
                                  For {globalData?.salefrom?.title}
                                </div>

                                <div className="p-0 m-1 me-0">
                                  {storeSettings?.invoiceSettings?.signature ? (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings?.invoiceSettings
                                          ?.signature
                                      }
                                      alt="Signature"
                                      width="120"
                                      style={{ marginBottom: "-5px" }} // Slight overlap fix if needed
                                    />
                                  ) : (
                                    <>
                                      <div className="pt-4">
                                        <hr
                                          className="m-1 ms-auto me-0 "
                                          style={{
                                            borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            maxWidth: "135px",
                                          }}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>

                                <div className="fw-bold font-10 pt-1">
                                  Authorized Signatory
                                </div>
                              </div>
                            </div>
                          </div>
                          {storeSettings?.negobillBranding && (
                            <div className="text-center mt-1 font-11">
                              Powered By <strong>NegoBill.com</strong>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="default-content">
                <p>No content available for this sale mode.</p>
              </div>
            )}          
          </div>
        )}
        <InvoiceInfoSidebar
          {...invoiceData}
          isData={isData}
          handleSelectedReturnSale={handleSelectedReturnSale}
        />
      </InvoiceModalLayout>
      {showConfirm && (
        <Convertinvoice
          onClose={() => setShowConfirm(false)}
          onConfirm={() => handleGenerateInvoice(data)}
        />
      )}

      <PaySettleModal
        isOpen={isPaySettleModalOpen}
        data={data}
        setIsPaySettleModalOpen={setIsPaySettleModalOpen}
        setIsMainModalOpen={setIsMainModalOpen}
        isBtnLoading={isBtnLoading}
        setBtnLoading={setBtnLoading}
      />
    </>
  );
};

export default LegendExecutiveInvoice;
